export enum ModalType {
  NONE = 'NONE',
  DEFAULT = 'DEFAULT',
  SEARCH = 'SEARCH',
}
